import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

import VueResource from "vue-resource";

import * as VueGoogleMaps from "vue2-google-maps";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

import moment from "moment-timezone";
import VueTables from "vue-crud-tables";
import "vue-datetime/dist/vue-datetime.css";
import VueMoment from "vue-moment";
import VueTelInput from "vue-tel-input";
import VueYoutube from "vue-youtube";
// import "vue2-animate/dist/vue2-animate.min.css";
// import animate from "animate.css";
//import "animate.css/animate.min.css";
// Vue.use(animate);
Vue.use(VueYoutube);

Vue.use(VueTelInput);

Vue.use(require("vue-moment"), {
  moment,
});

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBalE4vJmieJt5BqDZsfTS2XbcV0nKu5ng",
    libraries: "places", // This is required if you use the Autocomplete plugin
  },
});

import lodash from "lodash";
import VueLodash from "vue-lodash";

// name is optional
Vue.use(VueLodash, { name: "custom", lodash: lodash });

import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

import "./css/style.css";

Vue.use(VueSweetalert2);

Vue.use(VueResource);

Vue.use(VueTables);

// Adding Authorization to all interceptors
Vue.http.interceptors.push(function(request, next) {
  try {
    const vuexData = JSON.parse(window.localStorage.getItem("vuex"));
    // Only set authorization if user exists and has a valid token
    if (vuexData && vuexData.user && vuexData.user.token) {
      request.headers.set("authorization", vuexData.user.token);
    }
  } catch (e) {
    // console.log(e);
  }
  next();
});

Vue.http.interceptors.push((request, next) => {
  //request.headers['Authorization'] = auth.getAuthHeader()
  next(function(response) {
    if (
      response.status === 500 &&
      response.body &&
      response.body.error &&
      response.body.error.message === "Unauthenticated"
    ) {
      // Clear localStorage first, then reload
      window.localStorage.clear();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  });
});
//import VueTagManager from "vue-tag-manager";
import VueGtm from "@gtm-support/vue2-gtm";
import VueGtag from "vue-gtag";

// Vue.prototype.$gtm = Vue.gtm;

console.log("process.env.NODE_ENV: ", process.env.NODE_ENV);

if (process.env.NODE_ENV == "production") {
  // Do this before creating the Vue app
  // Vue.use(VueTagManager, {
  //   gtmId: "GTM-NTNVVZN",
  // });
  // Vue.use(VueGtm, {
  //   id: "GTM-NTNVVZN", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  //   // queryParams: {
  //   //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //   //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   //   gtm_preview: 'env-4',
  //   //   gtm_cookies_win: 'x'
  //   // },
  //   defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  //   compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  //   //nonce: '2726c7f26c', // Will add `nonce` to the script tag
  //   enabled: process.env.NODE_ENV === "production",
  //   debug: process.env.NODE_ENV !== "production",
  //   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  //   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  //   //ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  //   trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  // });

  Vue.use(
    VueGtag,
    {
      config: {
        id: "G-BRZQNJDQDT",
        params: {
          // debug_mode: process.env.NODE_ENV !== "production",
          send_page_view: true, // Ensure page views are sent automatically
        },
        appName: "server ui", // Move appName inside config
        dataLayerName: "gtagLayer", // Custom name to avoid GTM conflicts
      },
      pageTrackerScreenviewEnabled: true,
      enabled: process.env.NODE_ENV === "production",
    },
    router
  );

  // Vue.use(VueGtm, {
  //   id: "GTM-N33K8W8J",
  //   // dataLayerName: "gtmLayer", // Custom name for GTM
  //   enabled: process.env.NODE_ENV === "production",
  //   debug: process.env.NODE_ENV !== "production",
  //   loadScript: true,
  //   vueRouter: router,
  // });
}

window.App = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

// Initialize dialer state (fixes state desync after page refresh)
store.dispatch("dialer/initializeDialer");

// Make router globally accessible for Vuex modules
window.$appRouter = router;
